import { Loader2 } from 'lucide-react';

/**
 * PageLoadingFallback - Loading fallback component for lazy-loaded pages
 * แสดงขณะกำลังโหลด lazy-loaded components
 */
const PageLoadingFallback = () => {
  return (
    <div
      className='flex items-center justify-center min-h-screen bg-background'
      role='status'
      aria-live='polite'
      aria-label='Loading page'
    >
      <div className='flex flex-col items-center gap-4'>
        <Loader2 className='h-12 w-12 animate-spin text-primary' />
        <p className='text-lg text-muted-foreground'>Loading...</p>
      </div>
    </div>
  );
};

export default PageLoadingFallback;
